// `/start` — the destination of every sign-in (ADR-0016).
//
// It renders nothing of its own. It waits until it knows who is signed in, which
// workspace they are acting in and what that workspace has already done, then
// sends them to the first step they have not finished. For a brand new owner
// that is /connections; for a returning publisher it is /compose, which is where
// they were always going.

import { useEffect, useRef } from "react";
import { Navigate } from "react-router-dom";
import { useWorkspace } from "../lib/WorkspaceContext";
import { useEngagement } from "./EngagementContext";
import { landingRoute } from "./progress";
import { hasSeenTour, markTourSeen } from "./storage";

export function StartRedirect() {
  const { ready: wsReady, active } = useWorkspace();
  const { ready, progress, openTour } = useEngagement();
  const decided = useRef(false);

  const workspaceId = active?.workspace_id ?? null;
  const settled = wsReady && ready;

  // The tour opens exactly once per workspace per browser, and only for a
  // workspace that has done nothing at all. Someone who has connected an
  // account has understood the product well enough not to be interrupted.
  useEffect(() => {
    if (!settled || decided.current) return;
    decided.current = true;
    if (!workspaceId || !progress?.fresh || !progress.next) return;
    if (hasSeenTour(workspaceId)) return;
    markTourSeen(workspaceId);
    openTour(0);
  }, [settled, workspaceId, progress, openTour]);

  if (!settled) return <div className="wrap muted">Loading…</div>;
  return <Navigate to={landingRoute(progress)} replace />;
}
